import React,{createContext,useContext,useState,useEffect} from 'react';
import {supabase} from '../lib/supabase';

const ServiceTimesContext=createContext();

export const useServiceTimes=()=> {
  const context=useContext(ServiceTimesContext);
  if (!context) {
    throw new Error('useServiceTimes must be used within a ServiceTimesProvider');
  }
  return context;
};

export const ServiceTimesProvider=({children})=> {
  const [serviceTimes,setServiceTimes]=useState([]);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState(null);

  // Lade Servicezeiten aus der Datenbank
  const loadServiceTimes=async ()=> {
    try {
      setLoading(true);
      console.log('🕐 Loading service times...');

      const {data,error}=await supabase
        .from('service_times_a7b9c8d6e5')
        .select('*')
        .eq('is_active',true)
        .order('time',{ascending: true});

      if (error) {
        console.error('Error loading service times:',error);
        throw error;
      }

      console.log('✅ Service times loaded:',data);
      setServiceTimes(data || []);
      setError(null);
    } catch (err) {
      console.error('Error in loadServiceTimes:',err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Hole die Standard-Servicezeit
  const getDefaultServiceTime=()=> {
    const defaultTime=serviceTimes.find(st=> st.is_default && st.is_active);
    return defaultTime || serviceTimes[0] || {time: '12:00',label: 'Standard'};
  };

  // Hole alle aktiven Servicezeiten
  const getActiveServiceTimes=()=> {
    return serviceTimes.filter(st=> st.is_active);
  };

  // ✅ VERBESSERTE FUNKTION: Formatiere Servicezeit für Anzeige (ohne Sekunden)
  const formatServiceTime=(time)=> {
    if (!time) return '12:00 Uhr';
    
    // Entferne Sekunden falls vorhanden (z.B. "11:30:00" -> "11:30")
    const timeWithoutSeconds = time.includes(':') 
      ? time.split(':').slice(0, 2).join(':')
      : time;
      
    return `${timeWithoutSeconds} Uhr`;
  };

  // ✅ NEUE FUNKTION: Formatiere Service-Zeit mit Label
  const formatServiceTimeWithLabel=(serviceTime)=> {
    if (!serviceTime) return '12:00 Uhr';
    
    const formattedTime = formatServiceTime(serviceTime.time);
    
    if (serviceTime.label && serviceTime.label !== 'Standard') {
      return `${formattedTime} (${serviceTime.label})`;
    }
    
    return formattedTime;
  };

  // Lade Servicezeiten beim ersten Aufruf
  useEffect(()=> {
    loadServiceTimes();
  },[]);

  return (
    <ServiceTimesContext.Provider
      value={{
        serviceTimes,
        loading,
        error,
        loadServiceTimes,
        getDefaultServiceTime,
        getActiveServiceTimes,
        formatServiceTime,
        formatServiceTimeWithLabel // ✅ NEUE FUNKTION
      }}
    >
      {children}
    </ServiceTimesContext.Provider>
  );
};